export function getRoleFromAccessToken(): string | undefined {
    try {
        const token = localStorage.getItem('accessToken');
        if (!token) return undefined;
        const parts = token.split('.');
        if (parts.length !== 3) return undefined;
        const payload = JSON.parse(atob(parts[1]));
        const role = payload?.role as string | undefined;
        return role;
    } catch {
        return undefined;
    }
}

export function getUserIdFromAccessToken(): number | undefined {
    try {
        const token = localStorage.getItem('accessToken');
        if (!token) return undefined;
        const parts = token.split('.');
        if (parts.length !== 3) return undefined;
        const payload = JSON.parse(atob(parts[1]));
        const userId = payload?.user_id as number | undefined;
        return userId;
    } catch {
        return undefined;
    }
}

export function getAppIdFromAccessToken(): string | undefined {
    try {
        const token = localStorage.getItem('accessToken');
        if (!token) return undefined;
        const parts = token.split('.');
        if (parts.length !== 3) return undefined;
        const payload = JSON.parse(atob(parts[1]));
        const appId = payload?.app_id as string | undefined;
        return appId;
    } catch {
        return undefined;
    }
}

export function getLoginTypeFromAccessToken(): string | undefined {
    try {
        const token = localStorage.getItem('accessToken');
        if (!token) return undefined;
        const parts = token.split('.');
        if (parts.length !== 3) return undefined;
        const payload = JSON.parse(atob(parts[1]));
        const loginType = (payload?.login_type || payload?.grant_type) as string | undefined;
        return loginType;
    } catch {
        return undefined;
    }
}



export function getIsSuperuserFromAccessToken(): boolean {
    try {
        const token = localStorage.getItem('accessToken');
        if (!token) return false;

        const parts = token.split('.');
        if (parts.length !== 3) return false;

        const payload = JSON.parse(atob(parts[1]));

        return payload?.is_superuser === true;
    } catch {
        return false;
    }
}
